import { Reveal } from "./shared";
import { CLIENTS } from "../data/content";

const ROW_A = CLIENTS.filter((_, i) => i % 2 === 0);
const ROW_B = CLIENTS.filter((_, i) => i % 2 === 1);

const LogoCell = ({ c }) => (
    <div className="mx-2.5 sm:mx-3 flex h-[84px] w-44 sm:w-52 shrink-0 items-center justify-center border border-vec-border bg-white px-7 transition-colors duration-500 hover:border-vec-green/50 hover:bg-vec-mist/80">
        <img
            src={c.logo}
            alt={`${c.name} logo`}
            loading="lazy"
            className="h-9 sm:h-10 w-auto max-w-full object-contain"
        />
    </div>
);

const Track = ({ clients, reverse = false, duration = 58 }) => (
    <div className="flex overflow-hidden">
        <div
            className={`flex w-max items-center py-1.5 ${reverse ? "animate-marquee-rev" : "animate-marquee-dyn"}`}
            style={{ animationDuration: `${duration}s` }}
        >
            {[...clients, ...clients].map((c, i) => (
                <LogoCell key={`${c.name}-${i}`} c={c} />
            ))}
        </div>
    </div>
);

export const TrustedBy = () => (
    <section data-testid="trusted-by-section" className="relative bg-vec-mist py-14 lg:py-24 border-y border-vec-border overflow-hidden">
        <div className="vec-container">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                <div className="max-w-3xl">
                    <Reveal>
                        <div className="flex items-center gap-3 font-mono-tech text-[11px] sm:text-xs uppercase tracking-[0.22em] text-vec-green">
                            <span className="text-vec-charcoal/40">SEC 07</span>
                            <span className="h-px w-10 bg-vec-green/50" aria-hidden="true" />
                            <span>Clients</span>
                        </div>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-[1.12] uppercase text-vec-charcoal">
                            Trusted by Industry Leaders
                        </h2>
                    </Reveal>
                    <Reveal delay={0.14}>
                        <p className="mt-4 text-base sm:text-lg leading-relaxed text-vec-charcoal/70">
                            VEC delivers substation O&amp;M and power infrastructure services for
                            utilities, renewable energy and power sector clients.
                        </p>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <p className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-vec-charcoal/45 lg:text-right">
                        {String(CLIENTS.length).padStart(2, "0")} Client Organisations
                    </p>
                </Reveal>
            </div>
        </div>

        <Reveal delay={0.2}>
            <div
                data-testid="trusted-by-marquee"
                className="logo-wall group relative mt-8 space-y-3"
                aria-label={`Client logos: ${CLIENTS.map((c) => c.name).join(", ")}`}
            >
                <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-14 sm:w-28 bg-gradient-to-r from-vec-mist to-transparent" aria-hidden="true" />
                <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-14 sm:w-28 bg-gradient-to-l from-vec-mist to-transparent" aria-hidden="true" />
                <Track clients={ROW_A} duration={56} />
                <Track clients={ROW_B} reverse duration={68} />
            </div>
        </Reveal>
    </section>
);
